<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/wx61vr/tc-custom/9781631942655.jpg?1705766049578" alt="This image is the cover for the book Past Master"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Past Master
      </h1>
      <p class="bookDescription body article font2">
        <p><b>An expatriate U.S. Civil War veteran and sheriff turned novelist living in Edwardian London follows a deadly trail in search of a missing box.</b></p><p> It’s true that Denton and Henry James are both American writers now living in London, but they have little else in common: James has the gravitas (and perhaps the pomposity) of a living legend, master of the literary kingdom, while Denton . . . well, he’s scruffy and often covered in dog hair. But he does have this knack for sorting out problems, and James has just such a problem. There was a box, you see, and now it’s gone missing, and in the box were certain letters that, if made public, could be most embarrassing. Most embarrassing indeed.  </p><p><b>Praise for the Denton Mysteries</b></p><p><b>“Cameron . . . paints a striking portrait of London, and Denton is a hero whose unheroic side only makes his character more appealing.” —<i>Kirkus Reviews</i> on <i>The Frightened Man</i></b></p><b>“This is no dry, stuffy, repressed Edwardian depiction of events. There are beautiful, concise and accurate descriptions, comedy scenes and credible characters in this novel, which skillfully combines mystery and </b><b>history. ”—Historical Novel Society on <i>The Second Woman</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kenneth Cameron
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Felony & Mayhem
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?314090c5